<template>
  <div class="container">
    <a-form-model
      class="content"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="结算类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">应收</a-radio>
          <a-radio :value="2">应付</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="费用归属日期" required prop="finance_date">
        <a-date-picker v-model="form.finance_date" type="date" />
      </a-form-model-item>
      <a-form-model-item label="开票日期" v-show="form.type == 1">
        <a-date-picker v-model="form.invoice_date" type="date" />
      </a-form-model-item>
      <a-form-model-item label="项目" prop="project_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          @change="selectedPro"
        >
          <a-select-option
            v-for="item in proList"
            :key="item.id"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-show="form.project_id != ''" label="签约主体">
        <p>{{ companyName }}</p>
      </a-form-model-item>
      <a-form-model-item v-show="form.project_id != ''" label="客户名称">
        <p>{{ customerName }}</p>
      </a-form-model-item>
      <a-form-model-item label="费用大类" prop="pid">
        <a-select
          @change="selectedPID"
          v-model="form.pid"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option
            v-for="item in parentsList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-show="form.pid != ''"
        label="费用类型"
        prop="finance_type_id"
      >
        <a-select
          v-model="form.finance_type_id"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="费用名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="费用金额" prop="amount">
        <a-input-number style="width:150px" v-model="form.amount" :min="0" />
      </a-form-model-item>
      <a-form-model-item label="费用明细" prop="detail">
        <a-input v-model="form.detail" type="textarea" />
      </a-form-model-item>
      <a-form-model-item
        label="打款至"
        prop="xf_out_account_type"
        v-if="form.type == 2"
      >
        <a-radio-group v-model="form.xf_out_account_type">
          <a-radio :value="1">本人</a-radio>
          <a-radio :value="2">员工</a-radio>
          <a-radio :value="3">三方</a-radio>
          <a-radio :value="4">其他</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        prop="xf_third_part_id"
        label="三方"
        v-if="form.xf_out_account_type == 3"
      >
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.xf_third_part_id"
        >
          <a-select-option
            v-for="item in thirdList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        prop="xf_other_info"
        label="其他账户信息"
        v-if="form.xf_out_account_type == 4"
      >
        <a-input
          placeholder="身份证号|手机号|银行名称|银行卡号"
          v-model="form.xf_other_info"
        />
      </a-form-model-item>
      <a-form-model-item label="图片" v-show="form.type == 2">
        <div class="upImgStyle">
          <input
            id="travel"
            type="file"
            accept="image/*"
            @change="attentionPic"
          />
          <label for="travel">
            <a-icon type="plus" style="color: #d9d9d9; font-size: 40px" />
          </label>
          <ul>
            <li
              v-show="imageAttentionlUrl != ''"
              v-for="(item, l) in imageAttentionlUrl"
              :key="l"
            >
              <img :src="item" alt />
              <a-icon
                @click="deletedAttention(l)"
                class="close"
                type="close"
                style="color:#F56C6C"
              />
            </li>
          </ul>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item> </a-form-model-item> -->
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button style="margin-right: 20px" @click="resetForm">重置</a-button>
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      other: "",
      form: {
        type: "",
        finance_date: "",
        project_id: "",
        pid: "",
        finance_type_id: "",
        name: "",
        amount: "",
        detail: "",
        invoice_date: "",
        invoice_type: "",
        xf_out_account_type: "",
        xf_third_part_id: "",
        xf_other_info: ""
      },
      proList: [],
      customerName: "",
      companyName: "",
      parentsList: [],
      typeList: [],
      rules: {
        type: [
          {
            required: true,
            message: "请选择结算类型",
            trigger: "change"
          }
        ],
        xf_out_account_type: [
          {
            required: true,
            message: "请选择打款账户",
            trigger: "change"
          }
        ],
        xf_other_info: [
          {
            required: true,
            message: "请填写其他账户信息",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        pid: [
          {
            required: true,
            message: "请选择费用大类",
            trigger: "change"
          }
        ],
        finance_type_id: [
          {
            required: true,
            message: "请选择费用类型",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请填写费用名称",
            trigger: "blur"
          }
        ],
        invoice_type: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "blur"
          }
        ],
        invoice_send_type: [
          {
            required: true,
            message: "请选择递交方式",
            trigger: "blur"
          }
        ],
        invoice_send_no: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ],
        amount: [
          {
            required: true,
            message: "请填写金额",
            trigger: "blur"
          }
        ],
        xf_third_part_id: [
          {
            required: true,
            message: "请选择三方",
            trigger: "blur"
          }
        ],
        detail: [
          {
            required: true,
            message: "请填写费用明细",
            trigger: "blur"
          }
        ]
      },
      imageAttentionlUrl: [],
      getToken: [],
      thirdList: [],
      dateFormat: "YYYY-MM-DD"
    };
  },
  mounted() {
    this.getPro(); //获取项目
    this.getParents(); //获取大类
    this.getThirdCompany(); //获取三方公司
  },
  methods: {
    getThirdCompany() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.form.project_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.thirdList = res.data.data;
            // console.log(this.thirdList);
          }
        });
    },
    attentionPic(e) {
      if (e.target.files != "") {
        this.getUpImgToken(e);
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          this.imageAttentionlUrl.push(reader.result);
        };
      }
    }, //注意事项图片
    getUpImgToken(e) {
      let self = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1
        })
        .then(res => {
          this.getToken.push(res.data.data.business_file_key);
          // console.log(this.getToken1);
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              // console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              self.$info({
                title: "提示",
                content: "错误码：" + err.code + "！请重新选择图片",
                onOk() {}
              });
              self.imageAttentionlUrl = "";
            },
            complete(res) {
              // console.log("上传成功");
            }
          };
          var subscription = observable.subscribe(observer); // 上传开始
        });
    }, //上传至七牛云
    deletedAttention(key) {
      this.imageAttentionlUrl.splice(key, 1);
      this.getToken.splice(key, 1);
    }, //删除注意事项图片
    selectedPID() {
      this.getType(); //获取类型
    },
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
          // console.log(this.parentsList);
        }
      });
    },
    getType() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: this.form.pid,
        finance_source_id: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.typeList = res.data.data;
          // console.log(this.typeList);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          }
        });
    },
    selectedPro(val) {
      this.proList.forEach(element => {
        if (element.id == val) {
          this.companyName = element.company_name;
          this.customerName = element.customer_info.customer_name;
        }
      });
      this.form.xf_third_part_id = "";
      this.getThirdCompany(); //获取三方公司
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            type: this.form.type,
            name: this.form.name,
            finance_type_id: this.form.finance_type_id,
            project_id: this.form.project_id,
            finance_date:
              this.form.finance_date.length == 10
                ? this.form.finance_date
                : moment(this.form.finance_date).format("YYYY-MM-DD"),
            amount: this.form.amount,
            detail: this.form.detail,
            invoice_date:
              this.form.invoice_date.length == 10
                ? this.form.invoice_date
                : moment(this.form.invoice_date).format("YYYY-MM-DD"),
            xf_out_account_type: this.form.xf_out_account_type,
            xf_third_part_id:
              this.form.xf_out_account_type == 3
                ? this.form.xf_third_part_id
                : "",
            xf_other_info:
              this.form.xf_out_account_type == 4 ? this.form.xf_other_info : "",
            xf_images: JSON.stringify(this.getToken)
          };

          if (this.form.type != 1 || this.form.invoice_date == "") {
            delete params.invoice_date;
          }
          // console.log(params);
          let url =
            this.httpsBasic.url + this.httpsBasic.finance + "Finance/add";
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm();
                this.$emit("hideInAdd", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin-top: 30px;
  padding-bottom: 30px;
  .ant-form-item {
    margin-bottom: 14px;
  }
  .upImgStyle {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;
    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      z-index: 1;
    }
    > label {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      i {
        line-height: 100px;
      }
    }
    > ul {
      display: inline-block;
      li {
        display: inline-block;
        position: relative;
        margin-top: 10px;
        img {
          display: inline-block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
          border: 1px solid #d9d9d9;
          margin-bottom: 10px;
        }
        .close {
          position: absolute;
          right: 8px;
          top: 2px;
          font-size: 24px;
          color: #333;
        }
      }
    }
  }
}
</style>
